import * as React from "react"
import { cn } from "../../lib/utils"

export const Alert = React.forwardRef(({ className, variant = "default", ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(
      "rounded-lg border p-4",
      {
        "bg-destructive/15 text-destructive border-destructive/50": variant === "destructive"
      },
      className
    )}
    {...props}
  />
))
Alert.displayName = "Alert"

export const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm [&_p]:leading-relaxed", className)}
    {...props}
  />
))
AlertDescription.displayName = "AlertDescription"